<style lang="stylus" scoped>
    .attach-content
        font-size: 12px
        width 432px
        .attach-info
            height 32px
            display flex
            align-items center
            justify-content space-between
            margin-bottom 16px
            .name
                width 36px
                margin-right 24px
            .path
                outline none
                width 266px
                border-radius 3px
                .ivu-input
                    height 27px
                &:hover
                    border-color var(--themeHover)
            .btn
                background-color #017eff
                color white
                border-radius 3px
                width 80px
                height 27px
                text-align center
                line-height 27px
                text-overflow ellipsis
                white-space nowrap
                overflow hidden
                &:hover
                    background-color #075eb9
            .dialog-btn
                min-width 90px
                box-shadow none
        .attach-list
            height 160px
            margin-bottom 10px
            overflow-y auto
            border: 1px solid $box-bordercolor;
            border-radius: $box-radius;
            >.attach-item-wrap{
              padding: 6px
            }
            .attach-key
                text-indent: 36px;
                height 28px
                line-height 28px
                border-bottom 1px solid var(--border-color-attach-key)
            .attach-item
                height 28px
                text-indent 30px
                line-height 28px
                white-space nowrap
                text-overflow ellipsis
                overflow hidden
                word-break break-all
                border-radius: 6px;
                &:hover:not(.sel-attach){
                  background-color $main-hovercolor;
                }
            .sel-attach
                background-color $main-selectcolor;
        .attach-tool
            >svg{
              margin-right 20px
              cursor pointer
              width 24px
              height 24px
              color:var(--svg-color-gray-42-secondary);
              border-radius: $box-radius;
              &:hover{
                background-color: $main-hovercolor ;
              }
            }
    /deep/ .ivu-input{
      height: 100%
      border: 1px solid var(--border-color-box-6);
      border-radius: 6px;
      color: var(--text-color-primary);
    }
</style>

<template>
    <Dialog :title="$t('title')" :showFooter="true" :mask="true" @ok="confirm" @close="cancel">
        <div class="attach-content">
            <div class="attach-info">
                <div class="name">{{ $t("name") + ":" }}</div>
                <Input class="path" :maxlength="70" :value="selList && selList.name" @on-change="changeFileName" size="small" />
                <label for="attachFileSel">
                    <div class="dialog-btn" :title="$t('selAttach')">
                        {{ $t("selAttach") }}
                    </div>
                </label>
                <input id="attachFileSel" type="file" @change="chooseNewFile" style="display: none" />
            </div>
            <div class="attach-list" ref="attachList">
                <div class="attach-key">{{ $t("name") }}</div>
                <div class="attach-item-wrap">
                    <div
                        v-for="(item, index) in attachList"
                        class="attach-item"
                        :class="{ 'sel-attach': index === selIndex }"
                        @click="selIndex = index"
                    >
                        {{ item.name }}
                    </div>
                </div>
            </div>
            <div class="attach-tool">
                <iconSymbol @click.native="addAtt" name="property-addAttr" />
                <iconSymbol @click.native="deleteAtt" name="property-delAttr" />
            </div>
        </div>
    </Dialog>
</template>
<i18n>
{
  "zh": {
    "title": "附件",
    "name": "名字",
    "selAttach": "选择附件",
    "newAttach": "新建附件",
    "etc": "等",
    "noChoose": "没有选择附件"
  },
  "en": {
    "title": "Attachment",
    "name": "Name",
    "selAttach": "Select",
    "newAttach": "New Attachment",
    "etc": "etc.",
    "noChoose": "choosen no attachment"
  },
  "es": {
    "title": "Archivo adjunto",
    "name": "Nombre",
    "selAttach": "Selecciona",
    "newAttach": "Nuevo archivo adjunto",
    "etc": "etc",
    "noChoose": "No te seleccionaste ningún archivo adjunto"
  },
  "jp": {
    "title": "添付ファイル",
    "name": "名前",
    "selAttach": "添付ファイルを選択",
    "newAttach": "添付ファイルを作成",
    "etc": "など",
    "noChoose": "添付ファイルの選択なし"
  },
  "fr": {
    "title": "annexe",
    "name": "nom",
    "selAttach": "Choisissez la pièce jointe",
    "newAttach": "Nouvelle pièce jointe",
    "etc": "etc",
    "noChoose": "Aucune pièce jointe sélectionnée"
  },
  "pt": {
    "title": "Anexo",
    "name": "Nome",
    "selAttach": "Selecionar",
    "newAttach": "Anexo Novo",
    "etc": "etc.",
    "noChoose": "Não Escolheu Nenhum Anexo"
  },
  "de": {
    "title": "Anhang",
    "name": "Name",
    "selAttach": "Anhang auswählen",
    "newAttach": "Anhang erstellen",
    "etc": "usw.",
    "noChoose": "Keinen Anhang gewählt"
  },
  "it": {
    "title": "Allegato",
    "name": "Nome",
    "selAttach": "Scegli l'allegato",
    "newAttach": "Nuovo allegato",
    "etc": "ecc",
    "noChoose": "Nessun allegato selezionato"
  },
  "tw": {
    "title": "附件",
    "name": "名字",
    "selAttach": "選擇附件",
    "newAttach": "新建附件",
    "etc": "等",
    "noChoose": "沒有選擇附件"
  },
  "kr": {
    "title": "첨부파일",
    "name": "이름 ",
    "selAttach": "첨부파일 선택",
    "newAttach": "첨부파일 만들기 ",
    "etc": "etc",
    "noChoose": "첨부 파일이 선택되지 않았습니다"
  }
}
</i18n>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            Dialog,
        },
    })
    export default class AttachModal extends Vue {
        selIndex = 0;
        attachList = [];
        get showAttach() {
            return this.$store.state.dialog.showDialog;
        }
        set showAttach(data) {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: data,
            });
        }
        get selList() {
            return this.attachList[this.selIndex];
        }
        get activeFloatItem() {
            return this.$store.state.dialog.activeFloatItem;
        }
        get floatMenuList() {
            return this.$store.state.dialog.floatMenuList;
        }
        get activeShapeID() {
            return this.$store.state.shape.id;
        }
        set activeFloatItem(v) {
            this.$store.commit("setDialogState", {
                type: "activeFloatItem",
                data: v,
            });
        }
        changeFileName(e) {
            console.log(e.target.value);
            this.selList.name = e.target.value;
        }
        chooseNewFile(e) {
            let file = e.target.files[0];
            let index = file.name.lastIndexOf(".");
            if (~index) {
                let type = "." + file.name.substring(index + 1);
                let name = file.name.substring(0, index);
                this.selList.name = `${name.substring(0, 70 - type.length)}${type}`;
                this.selList.fileName = file.name;
            } else {
                this.selList.name = file.name;
                this.selList.fileName = file.name;
            }

            this.selList.file = file;
            e.target.value = null;
        }

        addAtt() {
            this.attachList.push({
                name: this.$t("newAttach"),
            });
            this.selIndex = this.attachList.length - 1;
            this.$nextTick(() => {
                (<Element>this.$refs.attachList).scrollTo({
                    left: 0,
                    top: (<Element>this.$refs.attachList).scrollHeight,
                    behavior: "smooth",
                });
            });
        }
        deleteAtt() {
            this.attachList.splice(this.selIndex, 1);
            if (this.selIndex >= this.attachList.length) {
                this.selIndex = this.attachList.length - 1;
            }
        }
        cancel() {
            this.showAttach = false;
            this.activeFloatItem = -1;
        }

        confirm() {
            let wrongAtt = this.attachList.find((item) => {
                return !item.file;
            });
            if (wrongAtt) {
                let msg = wrongAtt.name + (wrongAtt.name ? this.$t("etc") : "") + " " + this.$t("noChoose");
                this.$edMessage.error(msg);
                return;
            }
            let id = this.floatMenuList[this.activeFloatItem] ? this.floatMenuList[this.activeFloatItem].id : this.activeShapeID;
            window["_view"].modAttachment(id, this.attachList);

            this.showAttach = false;
            this.$store.commit("setStatus", {
                type: "showDialogMask",
                data: false,
            });
        }

        mounted() {
            let attachList = [];
            if (this.activeFloatItem != -1) {
                attachList = this.floatMenuList[this.activeFloatItem].attachList._attachs;
            } else if (this.activeShapeID != 0) {
                for (let i = 0; i < this.floatMenuList.length; ++i) {
                    if (this.floatMenuList[i].id == this.activeShapeID) {
                        attachList = this.floatMenuList[i].attachList._attachs;
                        break;
                    }
                }
            }
            this.attachList = attachList.map((item) => {
                return {
                    name: item._name,
                    file: item._fileKey,
                    fileName: item._fileName,
                };
            });
            if (!this.attachList.length) {
                this.addAtt();
            }
        }

        created() {}
    }
</script>
